import React from 'react'
import { Link, useParams } from 'react-router-dom'
import TaxPayerDetailForm from './TaxPayerDetailForm'

const TaxPayerDetail = () => {
  const { id } = useParams()

  return (
    <section className="space-y-4">
      <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
          <div>
            <h1 className="text-xl font-semibold text-slate-800">
              Taxpayer Detail
            </h1>
            <p className="text-sm text-slate-500">
              View taxpayer record #{id}
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            <Link
              to="/dash/taxpayers"
              className="inline-flex items-center justify-center rounded-xl border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-50"
            >
              Back to List
            </Link>

            <Link
              to={`/dash/taxpayers/edit/${id}`}
              className="inline-flex items-center justify-center rounded-xl bg-slate-800 px-4 py-2 text-sm font-medium text-white transition hover:bg-slate-700"
            >
              Edit Taxpayer
            </Link>
          </div>
        </div>
      </div>

      <TaxPayerDetailForm taxpayerId={id} />
    </section>
  )
}

export default TaxPayerDetail